<div class="document-upload-table">
  <ng-container *ngIf="this.gridData | async as data">
    <kendo-grid *ngIf="data.length > 0 || showWhenEmpty" [kendoGridBinding]="data" [sortable]="true" [pageable]="true"
      [pageSize]="pageSize" [loading]="isLoading" [resizable]="false">
      <div class="flair-column"></div>
      <kendo-grid-column field="fileName" title="File Name" [width]="200">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="download">
            <p>{{ dataItem.fileName }}</p>
            <img src="../../../../assets/images/Icon awesome-download.svg" alt="Download {{ dataItem.fileName }}"
              (click)="this.downloadRecord(dataItem.documentId)"
              (keydown.Space)="this.downloadRecord(dataItem.documentId)"
              (keydown.enter)="this.downloadRecord(dataItem.documentId)" />
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="documentType" title="Document Type" [width]="150">
        <ng-template kendoGridCellTemplate let-dataItem>
          <p>{{ dataItem.documentType }}</p>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="delete" title="Delete" [width]="50">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="delete">
            <img src="../../../../assets/images/Icon material-delete.svg" alt="Delete {{ dataItem.fileName }}"
              (click)="this.deleteRecord(dataItem.documentId)" (keydown.Space)="this.deleteRecord(dataItem.documentId)"
              (keydown.enter)="this.deleteRecord(dataItem.documentId)" tabindex="0" />
          </div>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </ng-container>
</div>